export default __webpack_public_path__ + "img/20cf963886301770cb3b1d1be60ceaec.svg";